<template>
  <div class="container-fluid card">
    <h6 class="section-title">Tag Details</h6>
    <div id="card">
      <div class="card-section">
        <popups></popups>  
        <div class="row section-body">
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Name</p>
            <input 
              id="tag-name" type="text" 
              name="name" :value="selectedTag.name"/>
          </div>
          <div class="col-sm-3 section-property-block">
            <p class="section-property-title">Created</p>
            <dropdown class="form-group">
              <div class="input-group">
                <input id="tag-created" disabled="disabled" type="datetime" 
                    name="name" 
                    :value="selectedTag.created | formatDateTime('MMMM DD YYYY, hh:mm A')"/>
                <div class="input-group-btn">
                  <btn class="dropdown-toggle" disabled><i class="glyphicon glyphicon-calendar"></i></btn>
                </div>
              </div>
              <template slot="dropdown">
                <li><date-picker/></li>
              </template>
            </dropdown>
          </div>
        </div>
        <div class="row section-body">
          <div class="col-sm-6 section-property-block">
            <p class="section-property-title">Description</p>
            <textarea id="tag-description" placeholder="--"
              type="text" name="description">{{ selectedTag.description }}</textarea>
          </div>
        </div>
      </div>  
      <!-- drop the thingy here -->
      <div class="card-section sub-section">
        <div class="row section-body button">
          <div class="col-sm-3 section-property-block">
            <btn type="primary" @click="submitTag()">Update</btn>
            <btn type="danger" @click="deleteTag()">Delete</btn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import store from '../../store.js';
import { bus } from '../../main';
import constants from '../../constants.js';
import Popups from '../Popups'
import { MultiSelect } from 'uiv'

export default {
  data () {
      return {
        errors: [],
        message: { type: 'warning', title: 'Tags', 'content': null },
      };
  },
  
  computed: {
    ...mapGetters([ 'hasErrors', 'getErrors' ]),
    ...mapState({
      dateFields: state => state.dateFields,
      dateFormat: state => state.dateFormat,      
      selectedTag: function(state) {
        return state.selectedTag;
      },
    }),
  },  
  
  methods: {
    reset: function() {
      this.errors = [];
      bus.$emit('reset', {});
    },
    
    redirect: function(action) {
      if (action == 'success') this.$router.push('/tags');
    },
        
    showPopup: function(value, type) {
      bus.$emit(type, { data: value });
      this.redirect(value.type);
    },
    
    confirmAction: function(data, action) {
      this.$confirm({
          title: 'Confirm Action',
          content: constants.message[action].action,
        }).then(() => {
          this.actionTag(data, action)
          }).catch(() => {
            this.$notify('Request has been cancelled.')
          });
    },
    
    actionTag: async function(data, action) {
      let failed = constants.message[action].failed;
      let success = constants.message[action].success;
      let response = await store.dispatch(((action == 'update')? 'updateSelectedTag' 
          : 'deleteSelectedTag'), { tag: data }); 
      
      if(response === 'success' || response != undefined){
        this.message.type = 'success';
        this.message.content = success;
      } else {
        this.message.type = 'warning';
        this.message.content = failed;
      }
      
      this.showPopup(this.message, 'notification');
    },
    
    submitTag: function () {
      this.reset();
      
      //form field names
      let data = {};
      let name = $("#tag-name").val();
      let description = $("#tag-description").val();
      
      if(name.length === 0) {
        this.errors.push('Tag name is required!'); 
      }
         
      data = {'id': this.selectedTag.id, 'name': name, 'description': description };
      if (this.errors.length > 0) {
        this.showPopup({'content': this.errors }, 'alert');
      } else this.confirmAction(data, 'update');
    },
    
    deleteTag: function () {
      let selectedTag = this.selectedTag;
      this.confirmAction(selectedTag, 'delete');
    },
  },

  components: { MultiSelect, Popups }, 
  
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchSelectedTag', { id: to.params.id });
    next();
  }, 
  
  beforeDestroy () {
    store.dispatch('resetErrors');
  },
};
</script>

<style scoped lang="scss">
@import "../../css/constants";

/* body select.select_box option */
body select option { padding: 0 4px; }
/* for IE and Edge */
select::-ms-expand { display: none; }
select:disabled::-ms-expand { background: #f60; }
.tool-tip{
  display: none;
  color: grey;
  background-color: #ececec;
  border-radius: 4px;
  position:absolute;
  margin-top: -40px;
  width: fit-content;
  padding-top:5px;
  padding-bottom:5px;
  padding-left: 5px;
  padding-right:5px;
  z-index: 100;
}
.tool-tip::after{
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #ececec transparent transparent transparent;
}
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.section-property:hover{
  display: block;
}
.container-fluid {
    margin-top: 25px;
    padding: auto;
}
.card-section {
  display: flex;
  flex-direction: column;
}

.card-sub-body {
  margin-top: 20px !important;
  border-top: 1px solid #ddd;
  padding: 25px 0 0 0;
}

.section-body { display: flex; flex-wrap: wrap; }
.sub-section { margin-top: 25px; }
.section-title {
    font-family: 'Roboto Slab', serif;
    font-weight: bold;
    color: $gray7;
    font-size: 20px;
    line-height: $p20;
    margin-bottom: $p24;
}
.section-property-block {
  margin-right: $p16;
	margin-bottom: $p16;
	// min-width: 140px;
}
.section-property-title {
    position:relative;
    z-index:1;
    color: $gray5;
    text-transform: uppercase;
    margin-bottom: $p16;
    font-size: 14px;
    line-height: $p14;
}
.section-property-container {
  height: $p32;
}
.section-property {
    color: #7b7b7b;
    border:none;
    word-wrap: break-word;
    cursor: pointer;
    width: 100%;
    font-size: 14px;
}
.detail-card-body{
    background-color: white;

}
@media (min-width: 576px){
  .col-sm-2 {
    max-width: 15.666667%;
  }
}
//Reset Grid
.col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4,
.col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-md-1, .col-md-10,
.col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6,
.col-md-7, .col-md-8, .col-md-9, .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12,
.col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8,
.col-sm-9, .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3,
.col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
  padding: 0;
}
//Reset row
.row {
  margin: 0;
}
.plus{
  border: 1px solid #cfcfcf;
  height: 35px;
  width: 35px;
  border-radius: 50%;
  display: flex;
  margin-top: 5px;
  cursor: pointer;
  margin-top: 30px;
  margin-left: 10px;
}
.plus > img{
  margin: auto;
}

@media only screen and (min-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
  }
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px;  }
  }
}

@media only screen and (max-width: 467px) {
  /* For mobile phones: */
  h1.detail-title {
    padding-left: 45px;
    i { display: inline-block; margin-right: 15px; }
  } 
}
</style>



// WEBPACK FOOTER //
// src/components/tag/TagDetail.vue